import { DetailsVisibilityTab, type DetailsPageProps } from 'app/main/components/page-layouts';

import CommunicationsDetailsTab from './tabs/CommunicationsDetailsTab';
import CommunicationsReadReceiptsTab from './tabs/CommunicationsReadReceiptsTab';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <CommunicationsDetailsTab {...props} />
	},
	{
		id: 'visibility',
		title: 'TAB_VISIBILITY',
		hidden: ({ authorizer }) => authorizer.cannot('view', 'communications_groups'),
		content: ({ model }) => <DetailsVisibilityTab module="communications" model={model} />,
		disabled: ({ isEdit }) => isEdit
	},
	{
		id: 'read-notifications',
		title: 'TAB_READ_RECEIPTS',
		hidden: ({ authorizer }) => authorizer.cannot('view', 'communications_readreceipts'),
		content: ({ model, refresh, updateRefresh }) => (
			<CommunicationsReadReceiptsTab
				comsUid={model.coms_uid}
				showReadReceipts={model.coms_readnotification}
				refresh={refresh}
				updateRefresh={updateRefresh}
			/>
		),
		disabled: ({ isEdit }) => isEdit
	}
];

export default tabs;
